function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo, useState } from 'react';
import { debounce } from 'lodash-es';
import { useForm, Controller } from 'react-hook-form';
import { usPhoneNumberValidation } from 'validators';
import { GridItem, Grid, TextField, Callout, Tooltip, USPhoneNumberInput } from 'seagull';
import { useResponsive } from "../../client-flow/contexts";
import ConditionalWrapper from "../ConditionalWrapper/ConditionalWrapper";
import { useStoreActions } from "../../store/store-context";
import { ResponsiveModal } from "../../client-flow/components/ResponsiveModal";
import { validateContact } from "../../business-logic/validators";
import { useEventReporter } from "../../event-reporter";
import { connectControllerToTextField } from "../../utils/react-hook-form.utils";
import styles from "./ManageContactModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export let ContactModalType = /*#__PURE__*/function (ContactModalType) {
  ContactModalType["Edit"] = "edit";
  ContactModalType["Create"] = "create";
  return ContactModalType;
}({});
export function ManageContactModal(props) {
  const {
    onClose: _onClose,
    contact,
    modalType,
    onSaveContact,
    onCancelClick,
    emailEditState,
    origin,
    extraCellsContent
  } = props;
  const {
    logBI
  } = useStoreActions();
  const {
    reportToGtm
  } = useEventReporter();
  const disableEmailField = emailEditState.isEmailReadonly;
  const {
    isDesktop
  } = useResponsive();
  const usPhoneValidator = usPhoneNumberValidation();
  const [disableSave, setDisableSave] = useState(false);
  const {
    handleSubmit,
    control
  } = useForm({
    mode: 'all',
    defaultValues: {
      companyName: (contact === null || contact === void 0 ? void 0 : contact.companyName) || '',
      email: (contact === null || contact === void 0 ? void 0 : contact.email) || '',
      firstName: (contact === null || contact === void 0 ? void 0 : contact.firstName) || '',
      lastName: (contact === null || contact === void 0 ? void 0 : contact.lastName) || '',
      phone: (contact === null || contact === void 0 ? void 0 : contact.phone) || ''
    }
  });
  const onSecondaryButtonClick = async () => {
    const shouldCloseModal = await onCancelClick();
    if (shouldCloseModal) return _onClose();
  };
  const saveContact = debounce(async data => {
    setDisableSave(true);
    const contactToSave = _objectSpread(_objectSpread(_objectSpread({}, contact), data), {}, {
      phone: data.phone || null
    });
    logBI(11601, {
      contact: contactToSave,
      origin
    });
    reportToGtm('form-success', 'contacts-table-clicked-save');
    const savedContact = await onSaveContact(contactToSave);
    if (savedContact) {
      _onClose(savedContact);
    }
    setDisableSave(false);
  }, 100);
  const partialModalProps = useMemo(() => {
    switch (modalType) {
      case ContactModalType.Create:
        {
          return {
            title: 'Create a new contact',
            primaryButtonLabel: 'Create',
            secondaryButtonLabel: 'Cancel'
          };
        }
      case ContactModalType.Edit:
        {
          return {
            title: 'Edit contact',
            primaryButtonLabel: 'Save',
            secondaryButtonLabel: 'Cancel'
          };
        }
    }
  }, [modalType]);
  return /*#__PURE__*/_jsx(ResponsiveModal, _objectSpread(_objectSpread({
    "data-testid": props['data-testid'] || 'manage-contact-modal',
    isDesktop: isDesktop,
    onClose: () => _onClose(),
    onPrimaryButtonClick: handleSubmit(saveContact),
    primaryButtonDisabled: disableSave,
    onSecondaryButtonClick: onSecondaryButtonClick
  }, partialModalProps), {}, {
    children: /*#__PURE__*/_jsx("div", {
      className: styles.container,
      children: /*#__PURE__*/_jsxs(Grid, {
        rowGap: "medium",
        children: [/*#__PURE__*/_jsx(GridItem, {
          span: isDesktop ? 6 : 12,
          children: /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "firstName",
            rules: {
              validate: validateContact.firstName
            },
            render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), {}, {
              label: "First name",
              testid: "first-name"
            }))
          })
        }), /*#__PURE__*/_jsx(GridItem, {
          span: isDesktop ? 6 : 12,
          children: /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "lastName",
            rules: {
              validate: validateContact.lastName
            },
            render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), {}, {
              label: "Last name",
              testid: "last-name"
            }))
          })
        }), /*#__PURE__*/_jsx(GridItem, {
          span: extraCellsContent ? 6 : 12,
          children: /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "companyName",
            rules: {
              validate: validateContact.companyName
            },
            render: renderProps => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), {}, {
              label: "Company name",
              testid: "company-name"
            }))
          })
        }), /*#__PURE__*/_jsx(GridItem, {
          span: extraCellsContent ? 6 : 12,
          children: /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "email",
            rules: {
              validate: validateContact.email
            },
            render: renderProps => /*#__PURE__*/_jsx(ConditionalWrapper, {
              condition: Boolean(emailEditState === null || emailEditState === void 0 ? void 0 : emailEditState.tooltipContent),
              wrapper: children => /*#__PURE__*/_jsx(Tooltip, {
                "data-testid": "readonly-email-tooltip",
                placement: "right",
                title: emailEditState === null || emailEditState === void 0 ? void 0 : emailEditState.tooltipContent,
                children: children
              }),
              children: /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), {}, {
                label: "Email address",
                testid: "email-address",
                disabled: disableEmailField
              }))
            })
          })
        }), /*#__PURE__*/_jsx(GridItem, {
          span: (extraCellsContent === null || extraCellsContent === void 0 ? void 0 : extraCellsContent.length) === 1 ? 6 : 12,
          children: /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "phone",
            rules: usPhoneValidator,
            render: renderProps => /*#__PURE__*/_jsx(USPhoneNumberInput, _objectSpread(_objectSpread({}, connectControllerToTextField(renderProps)), {}, {
              label: "Phone number (optional)",
              "data-testid": "phone-number"
            }))
          })
        }), extraCellsContent === null || extraCellsContent === void 0 ? void 0 : extraCellsContent.map((cellContent, index) => /*#__PURE__*/_jsx(GridItem, {
          span: 6,
          children: cellContent
        }, index)), /*#__PURE__*/_jsx(GridItem, {
          span: 12,
          children: /*#__PURE__*/_jsx(Callout, {
            children: "Adding a phone number allows us to send text reminders in addition to emails."
          })
        })]
      })
    })
  }));
}